import React from "react";

import Link from "next/link";

import PropTypes from "prop-types";
import formatHrefToSupportLegacyLink from "@/utils/formatHrefToSupportLegacyLink";

import { rowTitleCss } from "./RowHeading.style";

export const propTypes = {
  rowTitle: PropTypes.string,
  seeMoreURL: PropTypes.string,
};

const defaultProps = {
  rowTitle: "",
  seeMoreURL: "",
};

/**
 * @param {object} RowHeading - Renders title and description for rows
 */

export const RowHeading = (props) => {
  const { rowTitle, seeMoreURL } = props;

  return (
    <h2>
      <Link
        href={formatHrefToSupportLegacyLink(seeMoreURL)}
        passHref
        legacyBehavior
      >
        <a css={rowTitleCss}>{rowTitle}</a>
      </Link>
    </h2>
  );
};

RowHeading.defaultProps = defaultProps;
RowHeading.propTypes = propTypes;
export default RowHeading;
